//Imports
import React, { useContext, useEffect, useState } from "react";
import Select, { components } from 'react-select';
//Import Context
import staticData from '../../../contexts/staticData.json';
import { AppContext } from "../../../contexts/AppContext";
//Import Helpers
import { formatCurrency } from "../../../shared/helpers";
//Import Components
import MessageConfirmation from "../../messageConfirmation/MessageConfirmation";
import ViewPurchaseRequestForm from "./ViewPurchaseRequestForm";
import ViewFeeContractForm from "../FeeContractForm/ViewFeeContractForm";
//Import Icons
import see from '../../../assets/icons/visible.svg';
import downArrow from '../../../assets/icons/downArrow.svg';
import send from '../../../assets/icons/send.svg';
//Import CSS
import './requestPreview.css';

function RequestPreview({ formData, activity, onSubmit, onCancel, requestAmount, requestStatus, establishment, pme, typeOfRequest }) {
    const { establishmentList } = useContext(AppContext);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [showViewForm, setShowViewForm] = useState(false);

    useEffect(() => {
        const contenedor = document.querySelector('.request-form-container'); // o tu clase principal scrollable
        if (contenedor) contenedor.scrollTop = 0;
      }, []);

    const handleSubmit = () => {
        if (selectedDepartment) {
            onSubmit(selectedDepartment, formData.folio, requestAmount);
        } else {
            alert('Por favor, seleccione un departamento antes de enviar.')
        }
    };

    const handleViewForm = () => {
        setShowViewForm(true);
    };

    const handleCloseViewForm = () => {
        setShowViewForm(false);
    };

    // Función para filtrar items vacíos
    const filterEmptyItems = (items) => {
        return items.filter(item =>
            item.detail.trim() !== '' &&
            item.quantity.trim() !== '' &&
            (item.unitValue !== '' && item.unitValue !== null && item.unitValue !== undefined) &&
            item.totalValue !== ''
        );
    };

    // Preparar formData limpio para ViewPurchaseRequestForm
    const prepareFormDataForView = () => {
        return {
            ...formData,
            shoppingItems: filterEmptyItems(formData.shoppingItems)
        };
    };

    return (
        <section className='request-preview-container flex'>
            <p className='text-bold'>Vista Previa Solicitud Folio: {formData.folio}</p>
            <div className='flex'>
                <table>
                    <thead>
                        <tr>
                            <th>Dimensión</th>
                            <th>Nombre de la Acción</th>
                            <th>Monto Solicitud</th>
                            <th>Ver Oficio</th>
                            <th>Ver Formulario</th>
                            <th>Departamento Sostenedor</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td data-label='Dimensión'>{activity.dimension}</td>
                            <td data-label='Nombre de la Acción'>{activity.nameOfAction}</td>
                            <td data-label='Monto Solicitud'>{formatCurrency(requestAmount)}</td>
                            <td data-label='Ver Oficio'>{formData.attachments.officialDocs.map((doc, index) => (
                                <a key={index} href={doc.fileUrl} target='_blank' rel='noopener noreferrer'>
                                    <img src={see} className='icon' alt='Icono para ver documento de oficio.' />
                                </a>
                            ))}
                            </td>
                            <td data-label='Ver Formulario'>
                                <img src={see} className='icon' alt='Icono para ver formulario.' onClick={handleViewForm} />
                            </td>
                            <td data-label='Departamento Sostenedor'>
                                <label className='label-hidden' htmlFor='supportingDepartment'>Departamento Sostenedor a enviar </label>
                                <Select
                                    name='supportingDepartment'
                                    id='supportingDepartment'
                                    options={staticData.departments.map((department) => ({
                                        value: department,
                                        label: department
                                    }))}
                                    placeholder='Selecciona departamento a quien envia solicitud'
                                    className='custom-select'
                                    classNamePrefix='custom-select'
                                    components={{ DropdownIndicator }}
                                    value={selectedDepartment}
                                    onChange={(selectedOption) => setSelectedDepartment(selectedOption)}
                                    menuPortalTarget={document.body}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <article className='button-container flex'>
                <button onClick={handleSubmit} className='send-button flex'>
                    <img src={send} className='icon' alt='Icono para enviar solicitud de compra al departamento' />
                    <p>Enviar Solicitud de Compra al Departamento</p>
                </button>
                <button onClick={onCancel} className='cancel-button'>Cancelar</button>
            </article>
            <MessageConfirmation error={requestStatus.error} view={true} />
            {showViewForm && (
                typeOfRequest === 'feeContract' ? (
                    <ViewFeeContractForm
                        onClose={handleCloseViewForm}
                        requestDetails={{
                            request: {
                                requestDetails: {
                                    ...formData,
                                    requestAmount
                                },
                                idEstablishment: establishment,
                                idPME: pme
                            },
                            activity
                        }}
                        establishmentList={establishmentList}
                        fromRequestTracking={false}
                        fromPreview={true}
                    />
                ) : (
                    <ViewPurchaseRequestForm
                        onClose={handleCloseViewForm}
                        requestDetails={{
                            request: {
                                requestDetails: {
                                    ...prepareFormDataForView(),
                                    requestAmount
                                },
                                idEstablishment: establishment,
                                idPME: pme
                            },
                            activity
                        }}
                        establishmentList={establishmentList}
                        fromRequestTracking={false}
                        typeOfRequest={typeOfRequest}
                        fromPreview={true}
                    />
                )
            )}
        </section >
    );
};

const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <img src={downArrow} alt="CustomArrow" />
        </components.DropdownIndicator>
    );
};

export default RequestPreview;